import { render, staticRenderFns } from "./Mapx.vue?vue&type=template&id=3945cc48"
import script from "./Mapx.vue?vue&type=script&lang=js"
export * from "./Mapx.vue?vue&type=script&lang=js"
import style0 from "./Mapx.vue?vue&type=style&index=0&id=3945cc48&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports